module.exports = __webpack_public_path__ + "static/media/19_MBTA - Boston.149e6ff6.jpg";